import { FunctionComponent, useState, useEffect, useRef } from 'react';
import { Typography, SearchField, Tag, Checkbox, Button, Table }  from "@volvo/vcdk-react"
import { ColumnDef, flexRender, useReactTable, getCoreRowModel,getFilteredRowModel, getPaginationRowModel, getSortedRowModel } from '@tanstack/react-table';
import { Invoice, InvoiceItem, PeriodCost, Dealer } from '../../Types';

export const InvoiceTable: FunctionComponent<{ invoice: Invoice }> = ({ invoice }) => {
    
    const [columns, setColumns] = useState<ColumnDef<InvoiceItem>[]>([]);
    const [data, setData] = useState<InvoiceItem[]>([]);
    const isRetry = useRef<boolean>(false);
    useEffect(() => {
        let columns: ColumnDef<InvoiceItem>[] = [
            {
                id: "col-select",
                header: ({ table }) => (<Checkbox checked={true} onChange={() => {table.toggleAllRowsSelected(!table.getIsAllRowsSelected());}} aria-label="Select all rows" />), //table.getIsSomeRowsSelected() ? undefined: table.getIsAllRowsSelected()
                cell: ({ row }) => (<Checkbox checked={true} onChange={() => { row.toggleSelected(!row.getIsSelected()); }} aria-label={`Select row ${row.index + 1}`} />) //row.getIsSelected()
            },
            { id: 'col-product', header: 'Product', accessorKey: 'product', cell: info => info.getValue() },
            { id: 'col-specification', header: 'Specification', accessorKey: 'specification', cell: info => info.getValue() }
        ];
        for (let columnName of invoice.periodColumns) {
            columns.push({ id: `col-period-${columnName}`, header: columnName, accessorKey: 'periodColumns', cell: info => {
                let periodColumns: PeriodCost[] = info.getValue<PeriodCost[]>();
                let column = periodColumns.find(x => x.columnName === info.column.columnDef.header);
                return (<div style={{ display: 'flex', flexDirection: 'row', gap: 5 }}>
                            <div style={{ minWidth: '120px' }}><span>{column?.fromCost}</span><span style={{ marginLeft: '10px' }}>{column?.fromCurrency}</span></div>
                            <div style={{ marginLeft: '40px'}}><span>{column?.toCost}</span><span style={{ marginLeft: '10px' }}>{column?.toCurrency}</span></div>
                        </div>);
            } });
        }
        setColumns(columns);
        setData(invoice.itemList);
    }, []);
    
    const table = useReactTable({
        columns, data,
        getCoreRowModel: getCoreRowModel(),
        getFilteredRowModel: getFilteredRowModel(),
        //getPaginationRowModel: getPaginationRowModel(),
        getSortedRowModel: getSortedRowModel(),
        debugTable: false,
    });

    const retryFetchInvoice = () => {
        isRetry.current = true;
        //getDealerInvoice(payload);
    };

    return (
        <div style={{ border: "1px solid #E1E1E1", padding: 15, gap: 15, borderRadius: 8, backgroundColor: "#FFFFFF", display: 'grid' }}>
            <div style={{ display: "flex", justifyContent: 'space-between', alignItems: 'center' }}>
                <Typography variant="heading4">Application costs</Typography>
                <SearchField size='small' icon='search' />
            </div>
            <div style={{ gap: 15, display: 'flex', alignItems: 'center' }}>
                <Typography variant='subtitle1'>{invoice.dealerName}</Typography>
                {invoice.classList.map((dealerClass: string, index: number) => (
                    <Tag key={index} variant={`category-${index < 3 ? index + 4 : 6}` as any}>{dealerClass}</Tag>
                ))}
            </div>
            <div style={{ border: '1px solid #E1E1E1', backgroundColor: '#F7F7F7', borderRadius: 8, height: 'fit-content', padding: 8, gap: 8, display: 'flex', alignItems: 'center' }}>
                <Typography variant='subtitle2'>Dealer no.<Typography variant='button'>{invoice.dealerNo}</Typography></Typography>
                <div style={{ width: 1, height: 32, backgroundColor: '#A9A9A9' }}></div>
                <Typography variant='subtitle2'>Main dealer no.<Typography variant='button'>{invoice.mainDealerNo}</Typography></Typography>
                <div style={{ width: 1, height: 32, backgroundColor: '#A9A9A9' }}></div>
                <Typography variant='subtitle2'>Baldo ID.<Typography variant='button'>{invoice.baldoId ?? 'Null'}</Typography></Typography>
            </div>
            <Table>
                <table>
                    <thead>
                        {table.getHeaderGroups().map((headerGroup) => (
                            <tr key={headerGroup.id}>
                                {headerGroup.headers.map((header) => (
                                    <th key={header.id} colSpan={header.colSpan} scope="col">
                                        {flexRender(header.column.columnDef.header, header.getContext())}
                                    </th>
                                ))}
                            </tr>
                        ))}
                    </thead>
                    <tbody>
                        {table.getRowModel().rows.map((row) => (
                            <tr key={row.id}>{row.getVisibleCells().map((cell) => (
                                <td key={cell.id}>
                                    {flexRender(cell.column.columnDef.cell, cell.getContext())}
                                </td>
                            ))}</tr>
                        ))}
                    </tbody>
                </table>
            </Table>
        </div>
    );
}